interface TopRejectionReason {
  reason: string;
  count: number;
}

interface RejectionTrendsTileProps {
  reasons: TopRejectionReason[];
  loading?: boolean;
}

export default function RejectionTrendsTile({ reasons, loading }: RejectionTrendsTileProps) {
  const max = Math.max(...reasons.map((r) => r.count), 1);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03] p-6">
      <h3 className="text-base font-semibold text-gray-800 dark:text-white/90 mb-4">
        Top Rejection Reasons
      </h3>

      {loading && (
        <div className="flex items-center justify-center py-6">
          <div className="h-5 w-5 animate-spin rounded-full border-4 border-brand-500 border-r-transparent" />
        </div>
      )}

      {!loading && reasons.length === 0 && (
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
          No rejection data available.
        </p>
      )}

      {!loading && reasons.length > 0 && (
        <div className="space-y-3">
          {reasons.slice(0, 5).map((item) => (
            <div key={item.reason}>
              <div className="flex items-center justify-between mb-1">
                <span
                  className="text-sm text-gray-700 dark:text-gray-300 truncate max-w-[70%]"
                  title={item.reason}
                >
                  {item.reason}
                </span>
                <span className="text-sm font-semibold text-gray-800 dark:text-white/90 ml-2 shrink-0">
                  {item.count}
                </span>
              </div>
              <div className="w-full bg-gray-100 dark:bg-gray-700 rounded-full h-2">
                <div
                  className="h-2 rounded-full bg-red-500 dark:bg-red-400 transition-all"
                  style={{ width: `${Math.round((item.count / max) * 100)}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
